export default "__VITE_ASSET__DqKqoz$t__"